export default __webpack_public_path__ + "media/images/alert_badge-7496d50f8d881696aac50612817cea09.png";